import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  styled,
} from '@mui/material';
import { Apple as AppleIcon, Android as AndroidIcon, AdminPanelSettings as AdminIcon } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import BrandWordmark from '../../components/BrandWordmark';

// Shield Logo Component
const ShieldLogo = () => (
  <svg width="120" height="120" viewBox="0 0 120 120" style={{ filter: 'drop-shadow(0px 2px 5px rgba(0,0,0,0.2))' }}>
    <path d="M60 10L10 30V55C10 80.7 30 104.5 60 110C90 104.5 110 80.7 110 55V30L60 10Z" fill="none" stroke="#222222" strokeWidth="5"/>
    <path d="M60 10L10 30V55C10 80.7 30 104.5 60 110V10Z" fill="#dd2c00"/> {/* Red */}
    <path d="M60 10L110 30V55C110 80.7 90 104.5 60 110V10Z" fill="#1e88e5"/> {/* Blue */}
    <path d="M10 55C10 80.7 30 104.5 60 110V55H10Z" fill="#2e7d32"/> {/* Green */}
    <path d="M60 55H110C110 80.7 90 104.5 60 110V55Z" fill="#fbc02d"/> {/* Yellow */}
    <path d="M42 60L55 75L80 45" fill="none" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  borderRadius: 16,
  backgroundColor: '#ffffff',
  boxShadow: '0 8px 24px rgba(0, 0, 0, 0.1)',
}));

const StoreButton = styled(Button)(({ theme }) => ({
  padding: '12px 24px',
  borderRadius: 12,
  fontSize: '1rem',
  fontWeight: 600,
  textTransform: 'none',
  marginTop: theme.spacing(2),
  width: '100%',
  maxWidth: 280,
  '&:not(:last-child)': {
    marginBottom: theme.spacing(2),
  },
}));

const DownloadPage: React.FC = () => {
  return (
    <>
      {/* Add Google Fonts link for consistent typography */}
      <link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@400;600;700;800&family=Roboto:wght@400;500;700&family=Lato:wght@400;700&display=swap" rel="stylesheet" />
      
      <Container maxWidth="sm">
        <Box
          sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            py: 4,
          }}
        >
          <StyledPaper>
            {/* Replace the image with the SVG shield logo */}
            <Box sx={{ mb: 3 }}>
              <ShieldLogo />
            </Box>
            <Box sx={{ mb: 1 }}>
              <BrandWordmark variant="h4" component="h1" />
            </Box>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
              Get started with Check-Now by downloading our mobile app
            </Typography>
            
            <StoreButton
              variant="contained"
              startIcon={<AppleIcon />}
              onClick={() => window.open('https://apps.apple.com/us/app/check-now/id6745303459', '_blank')}
              sx={{
                backgroundColor: '#000000',
                '&:hover': {
                  backgroundColor: '#333333',
                },
              }}
            >
              Download on the App Store
            </StoreButton>
            
            <StoreButton
              variant="contained"
              startIcon={<AndroidIcon />}
              onClick={() => window.open('https://play.google.com/store/apps/details?id=com.jacobhartwell.SafetyCheckNow', '_blank')}
              sx={{
                backgroundColor: '#01875f',
                '&:hover': {
                  backgroundColor: '#017552',
                },
              }}
            >
              Get it on Google Play
            </StoreButton>

            <Link to="/" style={{ textDecoration: 'none', width: '100%', maxWidth: 280 }}>
              <StoreButton
                variant="outlined"
                startIcon={<AdminIcon />}
                sx={{
                  borderColor: '#1e88e5',
                  color: '#1e88e5',
                  '&:hover': {
                    backgroundColor: '#1e88e5',
                    color: 'white',
                    borderColor: '#1e88e5',
                  },
                }}
              >
                Access Admin Portal
              </StoreButton>
            </Link>
          </StyledPaper>
        </Box>
      </Container>
    </>
  );
};

export default DownloadPage; 